import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

@Injectable()
export class CatalogService {
  updateWithITSMCatalog(projectId): Promise<{status: string}> {
    return this.http.post<{status: string}>(`/api/catalog/updateWithITSMCatalog`,
      {projectId})
      .pipe(map(({status}) => ({status})))
      .toPromise();
  }

  constructor(private http: HttpClient) {}
}
